/**
 * Init API 逾時監控共用的計時來源。
 *
 * 獨立成檔的原因：pagePresence.js 也需要同一個時鐘，若從 initApiTimeoutMonitor.js import
 * 會形成循環依賴。initApiTimeoutMonitor.js 會 re-export 這兩個函式，對外路徑不變。
 */

/**
 * 統一計時來源：優先 performance.now()（monotonic，不受系統時間調整影響），
 * 不可用時 fallback 至 Date.now()
 * @returns {number} 時間（毫秒）
 */
export function nowMs() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return performance.now();
    }
    return Date.now();
}

/**
 * 取得目前使用的計時來源
 * @returns {string} "performance.now" 或 "Date.now"
 */
export function getClockSource() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return 'performance.now';
    }
    return 'Date.now';
}
